export interface AdBanner {
    id: string;
    imagePath: string;
    bannerGroup: string;
    url: string;
    active: boolean;
    position: number;
}

export const BANNER_GROUPS = [
    { value: 'SLIDER',            label: 'Slider' },
    { value: 'SLIDER_LEFT',       label: 'Slider Left' },
    { value: 'SLIDER_MOBILE',     label: 'Mobile Slider' },
    { value: 'INNER_PAGE_TOP',    label: 'Inner Page Top' },
    { value: 'INNER_PAGE_MIDDLE', label: 'Inner Page Middle' },
    { value: 'INNER_PAGE_BOTTOM', label: 'Inner Page Bottom' },
];
